export const get_security_transitions = `query get_security_transitions($paginator: Paginator!, $order: ListingOrder!, $filter: ListingFilter!){
    get_security_transitions(paginator: $paginator, order: $order, filter: $filter){
        security_transitions{
            transaction_code
            status
            from_account
            to_account
            amount
            security{
                short_name
                name
                stock_market_locality
                currency{
                    currency
                    name
                    decimal
                }
            }
            transfer_date
            fulfillment_date
        }
        page
        page_count
    }
}`;
